import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {ServiceDefinitionVersionComponent} from './service-definition-version.component';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import {MatDividerModule} from '@angular/material/divider';
import { CardModule } from '../../service/card/card.module';
import { CapabilityCardModule } from 'src/app/components/capability-card/capability-card.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from "@angular/material/expansion";
import { MatSelectModule } from '@angular/material/select';
import { ErrorModule } from 'src/app/components/error/error.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ServiceDefinitionVersionComponent
  ],
  imports: [
    CommonModule,
    BreadcrumbModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    CardModule,
    CapabilityCardModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatSelectModule,
    ErrorModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class ServiceDefinitionVersionModule {
}
